module.exports = __webpack_public_path__ + "img/like-program.de386d38.jpg";